// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3_oF8","range":"MonthRangeSwitch_range__2v-4y","disabled":"MonthRangeSwitch_disabled__2HIf3"};